<template>
    <div class="row" v-if="suportesList.length > 0">
        <div class="col-12">
            <b-card class="mb-3" no-body>
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />
                <table-app
                    class="p-0"
                    :data="suportesList"
                    :columns="columns"
                    :actions="actions"
                    @selected="setSupport"
                />
            </b-card>
        </div>
    </div>
</template>

<script>
import socket from "@/dashboard/socket";
export default {
    name: "Suportes",
    metaInfo() {
        return {
            title: this.$i18n.t("Suportes"),
        };
    },
    data() {
        return {
            suportesList: [],
            loading: false,
            prioridades: [
                { id: 1, value: "Baixa", color: "#62baff" },
                { id: 2, value: "Media", color: "#e7a22e" },
                { id: 3, value: "Alta", color: "#f19494" },
            ],
            status: [
                { id: 1, value: "Aberto", color: "#47cb8e" },
                { id: 2, value: "Fechado", color: "#f19494" },
            ],
            columns: [
                {
                    id: 1,
                    name: "status",
                    label: "Suportes",
                    filter: true,
                    search: true,
                    type: "input",
                    checked: 1,
                    template: true,
                    align: "start",
                    mask: `<div>
                                <span>Protocolo: <b>#id# </b></span>
                                <small>#data_cadastro#</small>
                                <b>#titulo#</b><br />
                                <small class="text-muted">
                                    #status_btn#
                                </small>
                            </div>`,
                },
            ],
            actions: [
                {
                    name: "Editar",
                    label: "Editar",
                    icon: "mdi mdi-square-edit-outline",
                    class: "px-2 mb-0 btn btn-sm btn-success",
                    emit: "selected",
                },
            ],
        };
    },
    mounted() {
        this.getSuportes();
        socket.on("support close", (name) => {
            // this.getSuportes();
            setTimeout(() => {
                this.getSuportes();
            }, 300);
        });
    },
    methods: {
        setSupport(id) {
            this.$emit("selected", id);
        },
        setPrioridade(id) {
            var temp = this.prioridades.filter((item) => item.id == id);
            return temp[0]
                ? `<span class="badge" style="background:${temp[0].color};color:white">${temp[0].value}</span>`
                : "";
        },
        setStatus(id) {
            var temp = this.status.filter((item) => item.id == id);
            return temp[0]
                ? `<span class="badge" style="background:${temp[0].color};color:white">${temp[0].value}</span>`
                : "";
        },
        getSuportes() {
            this.loading = true;
            axios
                .get("api/dashboard/support/list")
                .then((response) => {
                    this.suportesList = response.data;
                    this.$emit("size", this.suportesList.length);
                    this.loading = false;
                })
                .finally(() => {
                    this.$forceUpdate();
                })
                .catch((error) => {
                    this.$snack.success({
                        button: false,
                        text: error.response.data,
                    });
                    this.loading = false;
                });
        },
    },
};
</script>
